import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext'; // ✅ Import du contexte user

const MAX_CREDITS = 200;

const MessageCreditGauge = forwardRef((props, ref) => {
  const [credits, setCredits] = useState(null);
  const { t } = useTranslation();
  const { currentUser } = useAuth(); // ✅ Accès au currentUser

  // 👉 Ne rien afficher si l'utilisateur est abonné
  if (currentUser?.subscriptionStatus === 'active') {
    return null;
  }

  const fetchCredits = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/users/check-credits`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      const data = await res.json();

      if (res.ok && typeof data.monthlyMessageCredit === 'number') {
        setCredits(data.monthlyMessageCredit);
      } else {
        console.warn('⚠️ Format de réponse inattendu :', data);
      }
    } catch (err) {
      console.error('❌ Erreur lors du fetch des crédits message :', err);
    }
  };

  useImperativeHandle(ref, () => ({
    refreshCredits: fetchCredits,
  }));

  useEffect(() => {
    fetchCredits();
  }, []);

  const percentage =
    credits !== null
      ? Math.min((credits / MAX_CREDITS) * 100, 100)
      : 0;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ position: 'relative', display: 'inline-flex', mr: 1 }}>
        <CircularProgress
          variant="determinate"
          value={100}
          size={20}
          thickness={5}
          sx={{ color: '#DDD' }}
        />
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={20}
          thickness={5}
          sx={{
            color: '#000',
            position: 'absolute',
            left: 0,
          }}
        />
      </Box>

      <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
        {credits !== null ? t('messages_remaining', { count: credits }) : '...'}
      </Typography>
    </Box>
  );
});

export default MessageCreditGauge;
